<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn :disabled="disableFileInput" @click="$refs.file.click()">
					{{buttonLabel}}
				</v-btn>
				<input type="file" multiple v-show="false" ref="file" id="fileInput"
					:accept="acceptedFiles"
					v-on:change="confirmFileUpload">
			</v-flex>
			<v-flex xs12 class="mt-3">
				<div class="ml-2">
					<h3 class="mb-1">{{filesLabel}}</h3>
					<div v-for="(item, index) in uploadedFiles" :key="index">
						<strong>{{(index +1) }} {{item.fileName}}</strong>
						<v-tooltip right>
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="ma-0">
									<v-icon
										style="cursor: pointer"
										@click="downloadFile(item)">
										cloud_download
									</v-icon>
								</v-btn>
							</template>
							<span>Pobierz dokument</span>
						</v-tooltip>
						<v-tooltip right v-if="hasProjectPanelSupervisorModificationAccess()">
							<template v-slot:activator="{ on }">
								<v-btn icon v-on="on" class="ma-0">
									<v-icon
										style="cursor: pointer"
										@click="deleteFile(item)"
										color="red">
										delete
									</v-icon>
								</v-btn>
							</template>
							<span>Usuń dokument</span>
						</v-tooltip>
					</div>
				</div>
			</v-flex>
		</v-layout>
		<v-dialog persistent v-model="confirmationDialog" max-width="500">
			<v-card>
				<v-card-title>
					<span class="headline">Uwaga</span>
				</v-card-title>
				<v-card-text>
					<span class="caption">
						<b>
							Czy na pewno chcesz dodać poniższe pliki? Po zapisaniu nie będzie możliwości ich usunięcia.
						</b>
					</span>
					<div v-if="this.$refs.file" class="mt-2 ml-3">
						<div v-for="(item, index) in this.$refs.file.files" :key="index">
							{{item.name}}
						</div>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn @click="handleFileUpload">
						Zapisz
					</v-btn>
					<v-btn @click="cancelUpload">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {Files} from "../../../../utils/Files";

	export default {
		name: "ProjectFileView",

		props: {
			buttonLabel: {type: String, default: "Dodaj plik", required: false},
			filesLabel: {type: String, default: "Dodane pliki:", required: false},
			disableFileInput: {type: Boolean, default: false, required: false},
			loadFiles: {type: Function, required: true},
			uploadEndpoint: {type: String, default: "", required: true},
			deleteFunction: {type: Function, required: true}
		},

		data: function () {
			return {
				uploadedFiles: [],
				confirmationDialog: false
			};
		},

		created() {
			this.refresh();
		},

		methods: {
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			refresh() {
				this.uploadedFiles = this.loadFiles(this);
			},
			async handleFileUpload() {
				this.confirmationDialog = false;
				let formData = new FormData();
				for (let i = 0; i < this.$refs.file.files.length; ++i) {
					formData.append("files", this.$refs.file.files[i]);
				}
				await this.$http.post(process.env.VUE_APP_API_URL + this.uploadEndpoint + "?projectId="
					.concat(this.$route.params.projectId), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.loadFiles(this);
			},
			async confirmFileUpload () {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput("fileInput");
					return;
				}
				this.confirmationDialog = true;
			},
			cancelUpload () {
				Files.methods.clearFileInput("fileInput");
				this.confirmationDialog = false;
			},
			downloadFile(item) {
				Files.methods.downloadFileAsBlob(this, Files.methods.getProjectFile(item.hash), item.fileName);
			},
			deleteFile(file) {
				this.$confirm("Czy na pewno chcesz usunąć plik?", {
					icon: 'delete',
					title: 'Usuwanie pliku',
					color: 'primary',
					width: 500
				})
					.then(response => {
						if (response) {
							this.deleteFunction(this, file.hash);
						}
					});
			},
		}
	};
</script>

<style scoped>

</style>
